import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography'

export default function ProgressCounter(similarityLogs) {
  const maxLogs = 5;
  const{logs}= similarityLogs;
  const progress = (logs.length*100)/maxLogs;

  return (
    <Box sx={{marginLeft:'auto', display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'center', position:'relative'}}>
      <CircularProgress variant='determinate' value={progress}/>
      <Box
        sx={{
          top: 10,
          left: 5,
          bottom: 0,
          right: 0,
          position: 'absolute',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{ color: 'text.primary' }}
        >
          {`${Math.round(progress)}%`}
        </Typography>
      </Box>
    </Box>
  );
}
